import { useEffect } from 'react';

import { CAPTCHA_PROVIDER, CAPTCHA_PROVIDER_CONFIG } from '@shared/components/captcha/constants';

import { useSystemSettingsValue } from '../useSystemSettingsValue';

const KNOWN_CAPTCHA_PROVIDERS: string[] = Object.values(CAPTCHA_PROVIDER);

const useCaptchaProvider = (isActive = true) => {
  const { getValue, isFetching, error } = useSystemSettingsValue([CAPTCHA_PROVIDER_CONFIG], !isActive);
  const configuredCaptchaProvider = getValue(CAPTCHA_PROVIDER_CONFIG);
  const resolvedCaptchaProvider = KNOWN_CAPTCHA_PROVIDERS.find((provider) => provider === configuredCaptchaProvider);
  const captchaProvider = resolvedCaptchaProvider ?? CAPTCHA_PROVIDER.recaptcha;

  useEffect(() => {
    if (isActive && !isFetching && (error || !resolvedCaptchaProvider)) {
      console.warn('Failed to resolve captchaProvider: ', error ?? configuredCaptchaProvider);
    }
  }, [isActive, isFetching, error, configuredCaptchaProvider, resolvedCaptchaProvider]);

  return { captchaProvider, isLoadingCaptchaProvider: isFetching };
};

export default useCaptchaProvider;
